import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Environment from "nexia_mobile/environment";
import { Thermostat as ThermostatFeature } from "nexia_mobile/models/mixins/device_features";
import DefaultDeviceHeader from "nexia_mobile/components/Details/DetailsHeaders/DefaultDeviceHeader";
import ThermostatHeader from "nexia_mobile/components/Details/DetailsHeaders/ThermostatHeader";
import PivotThermostatHeader from "nexia_mobile/components/Details/DetailsHeaders/PivotThermostatHeader";
import AutomationHeader from "nexia_mobile/components/Details/DetailsHeaders/AutomationHeader";
import PhoneHeader from "nexia_mobile/components/Details/DetailsHeaders/PhoneHeader";
import PhoneModel from "nexia_mobile/models/phone";
import BuildingHeader from "nexia_mobile/components/Details/DetailsHeaders/BuildingHeader";
import LocationModel from "nexia_mobile/models/location";
import AutomationModel from "nexia_mobile/models/automation";

const isCommercial = Environment.isCommercial();
const DetailsHeaderContainer = ({ model }) => {
  if (model instanceof AutomationModel) {
    return <AutomationHeader model={model} />;
  }

  if (model instanceof PhoneModel) {
    return <PhoneHeader model={model} />;
  }

  if (model instanceof LocationModel) {
    return <BuildingHeader model={model} />;
  }

  if (model.hasFeature(ThermostatFeature)) {
    if (isCommercial) {
      return <PivotThermostatHeader model={model} />;
    } else {
      return <ThermostatHeader model={model} />;
    }
  }

  return <DefaultDeviceHeader model={model} />;
};
DetailsHeaderContainer.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
};

export default DetailsHeaderContainer;



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/DetailsHeaderContainer.jsx